import "./ButtonPath.css";
import { useChatboxDispatchContext, useChatboxStateContext } from "../../../context/ChatboxContext";

const ButtonPath = () => {

    const { valueTogglePath } = useChatboxStateContext();

    const dispatch = useChatboxDispatchContext();

    const togglePath = () => dispatch({ type: "togglePath" })

    return (
        <button id="kwalys-path" onClick={togglePath} className={valueTogglePath ? 'active' : ''}>
            <i className="fas fa-map-marker-alt" alt="path" style={{width: '18px', color : "black"}}></i>
        </button>
    );
};

export default ButtonPath;